/* import __COLOCATED_TEMPLATE__ from './qa-status-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    componentAttrs: {
      iconType: 'dot' | 'check' | 'alert';
    };
    item?: {
      text: string;
    };
  };
}

const QaStatusSelectItem = templateOnlyComponent<Signature>();
export default QaStatusSelectItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaStatusSelectItem': typeof QaStatusSelectItem;
    'inbox2/conversations-table/table-cells/qa-status-select-item': typeof QaStatusSelectItem;
  }
}
